import createReducer from '../utils/createReducer';
import ActionTypes from '../constants/ActionTypes';
import { combineReducers } from 'redux';

const status = createReducer(
  {
    hiprojects: true,
    closejob: false,
    jobdetails: false,
    feedbackMessage: false,
    feedbackQuote: false,
    feedbackReview: false
  },
  {
    [ActionTypes.MODAL_HIPROJECTS_STATUS]: (state, { payload }) => {
      return { ...state, hiprojects: payload };
    },
    [ActionTypes.MODAL_CLOSEJOB_STATUS]: (state, { payload }) => {
      return { ...state, closejob: payload };
    },
    [ActionTypes.MODAL_JOBDETAILS_STATUS]: (state, { payload }) => {
      return { ...state, jobdetails: payload };
    },
    [ActionTypes.UPDATE_MODAL_FEEDBACK_MESSAGE]: (state, { payload }) => {
      return { ...state, feedbackMessage: payload.status };
    },
    [ActionTypes.UPDATE_MODAL_FEEDBACK_QUOTE]: (state, { payload }) => {
      return { ...state, feedbackQuote: payload.status };
    },
    [ActionTypes.UPDATE_MODAL_FEEDBACK_REVIEW]: (state, { payload }) => {
      return { ...state, feedbackReview: payload.status };
    }
  }
);

const list = createReducer(
  {
    hiprojects: {},
    closejob: {},
    jobdetails: {},
    feedbackMessage: {
      status: false,
      connection: null
    },
    feedbackQuote: {
      status: false,
      connection: null
    },
    feedbackReview: {
      status: false,
      answerId: null,
      connection: null
    },
    account: {
      status: false
    }
  },
  {
    [ActionTypes.UPDATE_MODAL_FEEDBACK_MESSAGE]: (state, { payload }) => {
      return { ...state, feedbackMessage: { ...payload } };
    },
    [ActionTypes.UPDATE_MODAL_FEEDBACK_QUOTE]: (state, { payload }) => {
      return { ...state, feedbackQuote: { ...payload } };
    },
    [ActionTypes.UPDATE_MODAL_FEEDBACK_REVIEW]: (state, { payload }) => {
      return { ...state, feedbackReview: { ...payload } };
    },
    [ActionTypes.UPDATE_MODAL_ACCOUNT]: (state, { payload }) => {
      return { ...state, account: { status: payload } };
    }
  }
);

export default combineReducers({
  status,
  list
});
